export default __webpack_public_path__ + "static/media/timer-flash-line.02f35bcb.svg";